import {
  TActiveInstallmentContext,
  isFullyPaid,
  slotsLeft,
} from "./installmentRules";
import style from "./PaymentInstallments.module.css";

type Props = {
  context: TActiveInstallmentContext;
  /** What is wrong with the amounts being typed, when something is. */
  error?: string | null;
};

/** What the applicant can still do in this payment attempt, in one sentence. */
function describe(context: TActiveInstallmentContext) {
  if (isFullyPaid(context)) {
    return "The receipts add up to the full amount. Click Submit to send the payment for review.";
  }
  if (context.remainingBalance < 0) {
    return "The receipts add up to more than the amount due. Correct or delete a draft receipt.";
  }
  if (context.returnCount > 0) {
    return `This payment was returned. Pay the full amount of ${context.remainingBalance} INR in one receipt.`;
  }
  if (slotsLeft(context) === 1) {
    return `One receipt is left. It must be for exactly ${context.remainingBalance} INR.`;
  }
  return `You can pay in up to ${context.maxInstallmentsAllowed} receipts. ${context.activeInstallmentCount} of ${context.maxInstallmentsAllowed} used; the last one must equal the remaining balance.`;
}

/**
 * The line on Pay Now that tells the applicant where the installment payment
 * stands, and the reason when the amounts being typed cannot be saved.
 */
export default function InstallmentStatusNote({ context, error }: Props) {
  return (
    <>
      <p className={style.installmentNote}>{describe(context)}</p>
      {error && <p className={style.installmentError}>{error}</p>}
    </>
  );
}
